import { $t } from '@/locales'
export default [
  // {
  //   id: 'b0b002c4-c078-4c81-a2ec-c5696f3922fa',
  //   gid: 'd127dc38cbfe4cc1b492f14eb65a4965',
  //   cid: '1421445536204305993',
  //   contractId: 'OVC2021090813002',
  //   status: 1,
  //   price: 179.2,
  //   amountPaid: 179.2,
  //   totalNum: 10,
  //   saleSchemaId: 18,
  //   productId: 64,
  //   saleInfoId: 383,
  //   saleType: 1,
  //   units: '份',
  //   useScope: 0,
  //   subDetail: null,
  //   startTime: 1631030400000,
  //   endTime: 1662739199000,
  //   createTime: 1631094999000,
  //   giftProducts: null,
  //   orderSource: 1,
  //   saleSchemaName: '电子签名',
  //   productName: 'SaaS签署流量包',
  //   commodityId: 123,
  //   commodityName: '轩辕签署服务（企业版）',
  //   commodityNo: 'xuanyuansign001',
  //   saleInfoName: '企业10份',
  //   userName: null,
  //   userType: null,
  //   margin: 10,
  //   used: 0,
  //   companyCode: 'esign',
  //   companyName: '杭州天谷信息科技有限公司',
  //   isRenewalConsiderUsed: false,
  //   isAutoRenewal: false,
  //   showId: 'O202109081476584732',
  //   isUnLimitNum: false,
  //   isUnLimitTime: false,
  //   effectiveUnit: 'YEAR',
  //   effectiveDate: 1,
  //   paymentType: 0,
  //   payStatus: 1,
  //   hasElecInvoice: 0,
  //   payTypes: null,
  //   payOrderIds: null,
  //   thirdPayOrderIds: null,
  //   totalPay: null,
  //   standardPrice: 80,
  //   deductionPeriodTime: 15,
  //   levelPrice: null,
  //   billingMode: null,
  //   billingCycle: null,
  //   giftType: null,
  //   giftChannel: null,
  //   relPoolId: null,
  //   remark: null,
  //   showRemark: null,
  //   poolId: 2005466512,
  //   userInfo: null,
  //   contractStatus: 1,
  //   orderType: 1,
  //   thirdId: null,
  //   invoiceTotal: 0,
  //   unitPrice: 8,
  //   activeNo: 'jiuxitestactive99',
  //   isDiscount: true,
  //   isAgent: false,
  //   agentModel: 0,
  //   authorizedStatus: 0,
  //   num: 1,
  //   productType: 1,
  //   terminationTime: null,
  //   contractTime: null,
  //   originalPrice: 80,
  //   isStopShow: 1,
  //   webParameter: {
  //     status: '生效中',
  //     showLicenseDownload: false,
  //     zsShow: false,
  //     zsOperator: false,
  //     isShowElecInvoice: false,
  //     isShowPay: false,
  //     showChildServiceOpen: false,
  //     invoiceOperator: true,
  //     showLogisticsInfo: false,
  //     showSettlementRecord: false,
  //   },
  //   sellAmount: null,
  //   lockNum: 0,
  //   isDeliver: false,
  //   logisticInfo: [],
  //   showState: '生效中',
  //   startToEnd: '2021-09-08 - 2022-09-09',
  // },
  {
    id: 'b0b002c4-c078-4c81-a2ec-c5696f3922f2',
    gid: 'd127dc38cbfe4cc1b492f14eb65a4965',
    cid: '1421445536204305993',
    contractId: 'OVC2021090813002',
    status: 1,
    price: 179.2,
    amountPaid: 179.2,
    totalNum: 10,
    saleSchemaId: 18,
    productId: 64,
    saleInfoId: 383,
    saleType: 1,
    units: $t('份'),
    useScope: 0,
    subDetail: null,
    startTime: 1631030400000,
    endTime: 1662739199000,
    createTime: 1631094999000,
    giftProducts: null,
    orderSource: 1,
    saleSchemaName: $t('电子签名'),
    productName: $t('SaaS签署流量包'),
    commodityId: 123,
    commodityName: $t('轩辕签署服务（企业版）'),
    commodityNo: 'xuanyuansign001',
    saleInfoName: $t('企业10份'),
    userName: null,
    userType: null,
    margin: 10,
    used: 0,
    companyCode: 'KinggridBJ',
    companyName: $t('北京金格'),
    isRenewalConsiderUsed: false,
    isAutoRenewal: false,
    showId: 'O202109081476584732',
    isUnLimitNum: false,
    isUnLimitTime: false,
    effectiveUnit: 'YEAR',
    effectiveDate: 1,
    paymentType: 0,
    payStatus: 1,
    hasElecInvoice: 0,
    payTypes: null,
    payOrderIds: null,
    thirdPayOrderIds: null,
    totalPay: null,
    standardPrice: 80,
    deductionPeriodTime: 15,
    levelPrice: null,
    billingMode: null,
    billingCycle: null,
    giftType: null,
    giftChannel: null,
    relPoolId: null,
    remark: null,
    showRemark: null,
    poolId: 2005466512,
    userInfo: null,
    contractStatus: 1,
    orderType: 1,
    thirdId: null,
    invoiceTotal: 0,
    unitPrice: 8,
    activeNo: 'jiuxitestactive99',
    isDiscount: true,
    isAgent: false,
    agentModel: 0,
    authorizedStatus: 0,
    num: 1,
    productType: 1,
    terminationTime: null,
    contractTime: null,
    originalPrice: 80,
    isStopShow: 1,
    webParameter: {
      status: $t('生效中'),
      showLicenseDownload: false,
      zsShow: false,
      zsOperator: false,
      isShowElecInvoice: false,
      isShowPay: false,
      showChildServiceOpen: false,
      invoiceOperator: true,
      showLogisticsInfo: false,
      showSettlementRecord: false,
    },
    sellAmount: null,
    lockNum: 0,
    isDeliver: false,
    logisticInfo: [],
    showState: $t('生效中'),
    startToEnd: '2021-09-08 - 2022-09-09',
  },
  // {
  //   id: 'b0b002c4-c078-4c81-a2ec-c5696f3922f3',
  //   gid: 'd127dc38cbfe4cc1b492f14eb65a4965',
  //   cid: '1421445536204305993',
  //   contractId: 'OVC2021090813002',
  //   status: 1,
  //   price: 179.2,
  //   amountPaid: 179.2,
  //   totalNum: 10,
  //   saleSchemaId: 18,
  //   productId: 64,
  //   saleInfoId: 383,
  //   saleType: 1,
  //   units: '份',
  //   useScope: 0,
  //   subDetail: null,
  //   startTime: 1631030400000,
  //   endTime: 1662739199000,
  //   createTime: 1631094999000,
  //   giftProducts: null,
  //   orderSource: 1,
  //   saleSchemaName: '电子签名',
  //   productName: 'SaaS签署流量包',
  //   commodityId: 123,
  //   commodityName: '轩辕签署服务（企业版）',
  //   commodityNo: 'xuanyuansign001',
  //   saleInfoName: '企业10份',
  //   userName: null,
  //   userType: null,
  //   margin: 10,
  //   used: 0,
  //   companyCode: 'KinggridBJ',
  //   companyName: '北京金格',
  //   isRenewalConsiderUsed: false,
  //   isAutoRenewal: false,
  //   showId: 'O202109081476584732',
  //   isUnLimitNum: false,
  //   isUnLimitTime: false,
  //   effectiveUnit: 'YEAR',
  //   effectiveDate: 1,
  //   paymentType: 0,
  //   payStatus: 1,
  //   hasElecInvoice: 0,
  //   payTypes: null,
  //   payOrderIds: null,
  //   thirdPayOrderIds: null,
  //   totalPay: null,
  //   standardPrice: 80,
  //   deductionPeriodTime: 15,
  //   levelPrice: null,
  //   billingMode: null,
  //   billingCycle: null,
  //   giftType: null,
  //   giftChannel: null,
  //   relPoolId: null,
  //   remark: null,
  //   showRemark: null,
  //   poolId: 2005466512,
  //   userInfo: null,
  //   contractStatus: 1,
  //   orderType: 1,
  //   thirdId: null,
  //   invoiceTotal: 0,
  //   unitPrice: 8,
  //   activeNo: 'jiuxitestactive99',
  //   isDiscount: true,
  //   isAgent: false,
  //   agentModel: 0,
  //   authorizedStatus: 0,
  //   num: 1,
  //   productType: 1,
  //   terminationTime: null,
  //   contractTime: null,
  //   originalPrice: 80,
  //   isStopShow: 1,
  //   webParameter: {
  //     status: '生效中',
  //     showLicenseDownload: false,
  //     zsShow: false,
  //     zsOperator: false,
  //     isShowElecInvoice: false,
  //     isShowPay: false,
  //     showChildServiceOpen: false,
  //     invoiceOperator: true,
  //     showLogisticsInfo: false,
  //     showSettlementRecord: false,
  //   },
  //   sellAmount: null,
  //   lockNum: 0,
  //   isDeliver: false,
  //   logisticInfo: [],
  //   showState: '生效中',
  //   startToEnd: '2021-09-08 - 2022-09-09',
  // },
  // {
  //   id: 'b0b002c4-c078-4c81-a2ec-c5696f3922f4',
  //   gid: 'd127dc38cbfe4cc1b492f14eb65a4965',
  //   cid: '1421445536204305993',
  //   contractId: 'OVC2021090813002',
  //   status: 1,
  //   price: 179.2,
  //   amountPaid: 179.2,
  //   totalNum: 10,
  //   saleSchemaId: 18,
  //   productId: 64,
  //   saleInfoId: 383,
  //   saleType: 1,
  //   units: '份',
  //   useScope: 0,
  //   subDetail: null,
  //   startTime: 1631030400000,
  //   endTime: 1662739199000,
  //   createTime: 1631094999000,
  //   giftProducts: null,
  //   orderSource: 1,
  //   saleSchemaName: '电子签名',
  //   productName: 'SaaS签署流量包',
  //   commodityId: 123,
  //   commodityName: '轩辕签署服务（企业版）',
  //   commodityNo: 'xuanyuansign001',
  //   saleInfoName: '企业10份',
  //   userName: null,
  //   userType: null,
  //   margin: 10,
  //   used: 0,
  //   companyCode: 'KinggridJX',
  //   companyName: '江西金格',
  //   isRenewalConsiderUsed: false,
  //   isAutoRenewal: false,
  //   showId: 'O202109081476584732',
  //   isUnLimitNum: false,
  //   isUnLimitTime: false,
  //   effectiveUnit: 'YEAR',
  //   effectiveDate: 1,
  //   paymentType: 0,
  //   payStatus: 1,
  //   hasElecInvoice: 0,
  //   payTypes: null,
  //   payOrderIds: null,
  //   thirdPayOrderIds: null,
  //   totalPay: null,
  //   standardPrice: 80,
  //   deductionPeriodTime: 15,
  //   levelPrice: null,
  //   billingMode: null,
  //   billingCycle: null,
  //   giftType: null,
  //   giftChannel: null,
  //   relPoolId: null,
  //   remark: null,
  //   showRemark: null,
  //   poolId: 2005466512,
  //   userInfo: null,
  //   contractStatus: 1,
  //   orderType: 1,
  //   thirdId: null,
  //   invoiceTotal: 0,
  //   unitPrice: 8,
  //   activeNo: 'jiuxitestactive99',
  //   isDiscount: true,
  //   isAgent: false,
  //   agentModel: 0,
  //   authorizedStatus: 0,
  //   num: 1,
  //   productType: 1,
  //   terminationTime: null,
  //   contractTime: null,
  //   originalPrice: 80,
  //   isStopShow: 1,
  //   webParameter: {
  //     status: '生效中',
  //     showLicenseDownload: false,
  //     zsShow: false,
  //     zsOperator: false,
  //     isShowElecInvoice: false,
  //     isShowPay: false,
  //     showChildServiceOpen: false,
  //     invoiceOperator: true,
  //     showLogisticsInfo: false,
  //     showSettlementRecord: false,
  //   },
  //   sellAmount: null,
  //   lockNum: 0,
  //   isDeliver: false,
  //   logisticInfo: [],
  //   showState: '生效中',
  //   startToEnd: '2021-09-08 - 2022-09-09',
  // },
  // {
  //   id: 'b0b002c4-c078-4c81-a2ec-c5696f3922f4',
  //   gid: 'd127dc38cbfe4cc1b492f14eb65a4965',
  //   cid: '1421445536204305993',
  //   contractId: 'OVC2021090813002',
  //   status: 1,
  //   price: 179.2,
  //   amountPaid: 179.2,
  //   totalNum: 10,
  //   saleSchemaId: 18,
  //   productId: 64,
  //   saleInfoId: 383,
  //   saleType: 1,
  //   units: '份',
  //   useScope: 0,
  //   subDetail: null,
  //   startTime: 1631030400000,
  //   endTime: 1662739199000,
  //   createTime: 1631094999000,
  //   giftProducts: null,
  //   orderSource: 1,
  //   saleSchemaName: '电子签名',
  //   productName: 'SaaS签署流量包',
  //   commodityId: 123,
  //   commodityName: '轩辕签署服务（企业版）',
  //   commodityNo: 'xuanyuansign001',
  //   saleInfoName: '企业10份',
  //   userName: null,
  //   userType: null,
  //   margin: 10,
  //   used: 0,
  //   companyCode: 'esign',
  //   companyName: '杭州天谷信息科技有限公司',
  //   isRenewalConsiderUsed: false,
  //   isAutoRenewal: false,
  //   showId: 'O202109081476584732',
  //   isUnLimitNum: false,
  //   isUnLimitTime: false,
  //   effectiveUnit: 'YEAR',
  //   effectiveDate: 1,
  //   paymentType: 0,
  //   payStatus: 1,
  //   hasElecInvoice: 0,
  //   payTypes: null,
  //   payOrderIds: null,
  //   thirdPayOrderIds: null,
  //   totalPay: null,
  //   standardPrice: 80,
  //   deductionPeriodTime: 15,
  //   levelPrice: null,
  //   billingMode: null,
  //   billingCycle: null,
  //   giftType: null,
  //   giftChannel: null,
  //   relPoolId: null,
  //   remark: null,
  //   showRemark: null,
  //   poolId: 2005466512,
  //   userInfo: null,
  //   contractStatus: 1,
  //   orderType: 1,
  //   thirdId: null,
  //   invoiceTotal: 0,
  //   unitPrice: 8,
  //   activeNo: 'jiuxitestactive99',
  //   isDiscount: true,
  //   isAgent: false,
  //   agentModel: 0,
  //   authorizedStatus: 0,
  //   num: 1,
  //   productType: 1,
  //   terminationTime: null,
  //   contractTime: null,
  //   originalPrice: 80,
  //   isStopShow: 1,
  //   webParameter: {
  //     status: '生效中',
  //     showLicenseDownload: false,
  //     zsShow: false,
  //     zsOperator: false,
  //     isShowElecInvoice: false,
  //     isShowPay: false,
  //     showChildServiceOpen: false,
  //     invoiceOperator: true,
  //     showLogisticsInfo: false,
  //     showSettlementRecord: false,
  //   },
  //   sellAmount: null,
  //   lockNum: 0,
  //   isDeliver: false,
  //   logisticInfo: [],
  //   showState: '生效中',
  //   startToEnd: '2021-09-08 - 2022-09-09',
  // },
]
